// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"548":"857122ae","770":"16bf1d26"}[chunkId] + ".chunk.css";
};